import { createContext } from 'react';
import { ViewState } from './ViewState';

export const PersistViewStateContext = createContext<(viewState: ViewState | undefined) => void>(() => {});